import React from 'react';
import { v4 as uuid } from 'uuid';

import { error as logError, getSourceMapLocation } from '@eika-infrastruktur/log';
import { QueryKey, ThrowOnError } from '@eika-infrastruktur/react-query';
import { RequestException } from '@eika-infrastruktur/request/src/exceptions';

const NAMESPACE = 'dagligbank-lokalbank-web';
const getSourceMapError = getSourceMapLocation(NAMESPACE);

export const logErrorFromErrorBoundary =
    (namespace: string, ignoreBackendErrors = true) =>
    async (error: Error, errorInfo: React.ErrorInfo) => {
        if (
            ignoreBackendErrors &&
            (error.name.includes('RequestExceptionWithResponse') || error instanceof RequestException)
        )
            return;
        const rcid = uuid();
        await logError(
            {
                ...error,
                message: error.message,
                errorName: error.name,
                stack: error.stack,
                errorInfo,
                url: window.location.href,
                namespace,
                sourceMapLocation: await getSourceMapError(errorInfo),
            },
            rcid,
        );
    };

export const logErrorOnQueryError: ThrowOnError<unknown, Error, unknown, QueryKey> = (error, orgQuery) => {
    if (!(error instanceof RequestException)) {
        const errorType = error as Error;
        const rcid = uuid();
        logError(
            {
                queryKey: orgQuery?.queryKey,
                orgError: error,
                message: errorType?.message,
                errorName: errorType?.name,
                stack: errorType?.stack,
                url: window.location.href,
            },
            rcid,
        );
    }
    return false;
};
